export default __webpack_public_path__ + "static/media/Number_1_selected.89c9f2c1.svg";